// QRCodeCanvas.js
import React, { useEffect } from 'react';
import QRCodeLib from 'qrcode';

const QRCodeCanvas = ({ value, size, canvasRef }) => {
  useEffect(() => {
    const canvas = canvasRef.current;

    if (canvas) {
      QRCodeLib.toCanvas(canvas, value, { width: size });
    }
  }, [value, size, canvasRef]);

  return <canvas ref={canvasRef} />;
};

export default QRCodeCanvas;
